import { Component, OnInit, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SharedService } from './shared.service';
import { Labels } from './model/language.model.class';
import { UserFeatures } from './model/model.class';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() labels: Labels;
  @Input() language: string = 'EN';
  @Output() userButtonClicked = new EventEmitter<void>();
  @Output() languageButtonClicked = new EventEmitter<void>();
  user: any = null;
  userFeatures: any = null;
  navLinks = [];

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    this.sharedService.user$.subscribe(selectedUser => {
      if (selectedUser) {
        this.user = selectedUser;
        this.userFeatures = {
          workload: true,
          visitday: true,
          statistics: false
        };
      } else {
        this.userFeatures = null; // Reset quando fai logout
      }
    });

    const lang = localStorage.getItem('language');
    if (lang) {
      this.language = lang.toUpperCase();
    }

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['labels'] && this.labels)

      if (!this.navLinks || this.navLinks.length === 0) {
        this.navLinks = [
          { id: 0, label: this.labels.LinkTitle['Home'], icon: 'assets/home.svg', iconActive: 'assets/home-red.svg', active: true },
          { id: 1, label: this.labels.LinkTitle['Workload'], icon: 'assets/workload.svg', iconActive: 'assets/workload-red.svg', active: false, feature: 'workload', enabled: this.sharedService.HasFeatures(UserFeatures.OwnAreasSalesreps) },
          { id: 2, label: this.labels.LinkTitle['VisitDay'], icon: 'assets/visit.svg', iconActive: 'assets/visit-red.svg', active: false, feature: 'visitday', enabled: this.sharedService.HasFeatures(UserFeatures.OwnSalesreps) },
          { id: 3, label: this.labels.LinkTitle['Statistics'], icon: 'assets/statistics.svg', iconActive: 'assets/statistics-red.svg', active: false, feature: 'statistics', enabled: this.sharedService.HasFeatures(UserFeatures.OwnSalesreps) },
        ];
      } else {
        this.navLinks.forEach(link => {
          switch (link.id) {
            case 0: link.label = this.labels.LinkTitle['Home']; break;
            case 1: link.label = this.labels.LinkTitle['Workload']; break;
            case 2: link.label = this.labels.LinkTitle['VisitDay']; break;
            case 3: link.label = this.labels.LinkTitle['Statistics']; break;
          }
        });

    }
  }


  setActive(item) {
    this.navLinks.forEach(link => link.active = (link.label === item.label));
    this.sharedService.SwitchTab(item.id);
  }

  onUserPopupClick() {
    this.userButtonClicked.emit();
  }

  onLanguageClick(event: Event) {
    event.preventDefault();
    this.languageButtonClicked.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/header.component.ts